export const managerIntersection = (callback) => {
  let timeoutId

  const delayLoad = () => {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        callback();
        cancelDelayLoad();
      }, 50);
    }
  };

  const cancelDelayLoad = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null
    }
  };

  return entry => entry.isIntersecting ? delayLoad() : cancelDelayLoad()
};


const observerOptions = {
  root: null,
  threshold: 0,
  rootMargin: '500px',
}

export default (callback, options = observerOptions) => {
  const manager = managerIntersection(callback)

  return new IntersectionObserver(([entry]) => manager(entry), options);
}
